// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPagination } from './IPagination';
import {
    IPaginationFromJSON,
    IPaginationFromJSONTyped,
    IPaginationToJSON,
    IPaginationToJSONTyped,
} from './IPagination';

/**
 * 
 * @export
 * @interface IClaimParticipantSearchDto
 */
export interface IClaimParticipantSearchDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IClaimParticipantSearchDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimParticipantSearchDto
     */
    claim_status?: Array<IClaimParticipantSearchDtoClaimStatusEnum>;
    /**
     * 
     * @type {number}
     * @memberof IClaimParticipantSearchDto
     */
    employee_id?: number;
    /**
     * 
     * @type {IPagination}
     * @memberof IClaimParticipantSearchDto
     */
    pagination?: IPagination;
}

/**
* @export
* @enum {string}
*/
export enum IClaimParticipantSearchDtoClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the IClaimParticipantSearchDto interface.
 */
export function instanceOfIClaimParticipantSearchDto(value: object): value is IClaimParticipantSearchDto {
    return true;
}

export function IClaimParticipantSearchDtoFromJSON(json: any): IClaimParticipantSearchDto {
    return IClaimParticipantSearchDtoFromJSONTyped(json, false);
}

export function IClaimParticipantSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimParticipantSearchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_ids': json['claim_ids'] == null ? undefined : json['claim_ids'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'pagination': json['pagination'] == null ? undefined : IPaginationFromJSON(json['pagination']),
    };
}

export function IClaimParticipantSearchDtoToJSON(json: any): IClaimParticipantSearchDto {
    return IClaimParticipantSearchDtoToJSONTyped(json, false);
}

export function IClaimParticipantSearchDtoToJSONTyped(value?: IClaimParticipantSearchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_ids': value['claim_ids'],
        'claim_status': value['claim_status'],
        'employee_id': value['employee_id'],
        'pagination': IPaginationToJSON(value['pagination']),
    };
}

